/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createHazard = /* GraphQL */ `
  mutation CreateHazard(
    $input: CreateHazardInput!
    $condition: ModelHazardConditionInput
  ) {
    createHazard(input: $input, condition: $condition) {
      id
      HZDID
      employee
      employeeName
      dateObserved
      timeObserved
      businessUnit
      locationType
      location
      externalLocationType
      externalLocation
      externalCustomer
      country
      otherCountry
      observationType
      observationDescription
      immediateActionTaken
      immediateActionTakenDetails
      furtherActionRequired
      status
      justification
      createdBy
      createdByEmail
      closeDate
      files
      actions {
        nextToken
        startedAt
        __typename
      }
      observationCategory
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateHazard = /* GraphQL */ `
  mutation UpdateHazard(
    $input: UpdateHazardInput!
    $condition: ModelHazardConditionInput
  ) {
    updateHazard(input: $input, condition: $condition) {
      id
      HZDID
      employee
      employeeName
      dateObserved
      timeObserved
      businessUnit
      locationType
      location
      externalLocationType
      externalLocation
      externalCustomer
      country
      otherCountry
      observationType
      observationDescription
      immediateActionTaken
      immediateActionTakenDetails
      furtherActionRequired
      status
      justification
      createdBy
      createdByEmail
      closeDate
      files
      actions {
        nextToken
        startedAt
        __typename
      }
      observationCategory
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteHazard = /* GraphQL */ `
  mutation DeleteHazard(
    $input: DeleteHazardInput!
    $condition: ModelHazardConditionInput
  ) {
    deleteHazard(input: $input, condition: $condition) {
      id
      HZDID
      employee
      employeeName
      dateObserved
      timeObserved
      businessUnit
      locationType
      location
      externalLocationType
      externalLocation
      externalCustomer
      country
      otherCountry
      observationType
      observationDescription
      immediateActionTaken
      immediateActionTakenDetails
      furtherActionRequired
      status
      justification
      createdBy
      createdByEmail
      closeDate
      files
      actions {
        nextToken
        startedAt
        __typename
      }
      observationCategory
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createHazardActions = /* GraphQL */ `
  mutation CreateHazardActions(
    $input: CreateHazardActionsInput!
    $condition: ModelHazardActionsConditionInput
  ) {
    createHazardActions(input: $input, condition: $condition) {
      id
      Hazard {
        id
        HZDID
        employee
        employeeName
        dateObserved
        timeObserved
        businessUnit
        locationType
        location
        externalLocationType
        externalLocation
        externalCustomer
        country
        otherCountry
        observationType
        observationDescription
        immediateActionTaken
        immediateActionTakenDetails
        furtherActionRequired
        status
        justification
        createdBy
        createdByEmail
        closeDate
        files
        observationCategory
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      HZDID
      action
      logs {
        nextToken
        startedAt
        __typename
      }
      assignedTo
      businessUnit
      status
      dueDate
      originalDueDate
      _delete
      assignedToEmail
      completedDate
      sendEmail
      voidJustification
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      hazardActionsId
      __typename
    }
  }
`;
export const updateHazardActions = /* GraphQL */ `
  mutation UpdateHazardActions(
    $input: UpdateHazardActionsInput!
    $condition: ModelHazardActionsConditionInput
  ) {
    updateHazardActions(input: $input, condition: $condition) {
      id
      Hazard {
        id
        HZDID
        employee
        employeeName
        dateObserved
        timeObserved
        businessUnit
        locationType
        location
        externalLocationType
        externalLocation
        externalCustomer
        country
        otherCountry
        observationType
        observationDescription
        immediateActionTaken
        immediateActionTakenDetails
        furtherActionRequired
        status
        justification
        createdBy
        createdByEmail
        closeDate
        files
        observationCategory
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      HZDID
      action
      logs {
        nextToken
        startedAt
        __typename
      }
      assignedTo
      businessUnit
      status
      dueDate
      originalDueDate
      _delete
      assignedToEmail
      completedDate
      sendEmail
      voidJustification
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      hazardActionsId
      __typename
    }
  }
`;
export const deleteHazardActions = /* GraphQL */ `
  mutation DeleteHazardActions(
    $input: DeleteHazardActionsInput!
    $condition: ModelHazardActionsConditionInput
  ) {
    deleteHazardActions(input: $input, condition: $condition) {
      id
      Hazard {
        id
        HZDID
        employee
        employeeName
        dateObserved
        timeObserved
        businessUnit
        locationType
        location
        externalLocationType
        externalLocation
        externalCustomer
        country
        otherCountry
        observationType
        observationDescription
        immediateActionTaken
        immediateActionTakenDetails
        furtherActionRequired
        status
        justification
        createdBy
        createdByEmail
        closeDate
        files
        observationCategory
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      HZDID
      action
      logs {
        nextToken
        startedAt
        __typename
      }
      assignedTo
      businessUnit
      status
      dueDate
      originalDueDate
      _delete
      assignedToEmail
      completedDate
      sendEmail
      voidJustification
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      hazardActionsId
      __typename
    }
  }
`;
export const createHazardActionLog = /* GraphQL */ `
  mutation CreateHazardActionLog(
    $input: CreateHazardActionLogInput!
    $condition: ModelHazardActionLogConditionInput
  ) {
    createHazardActionLog(input: $input, condition: $condition) {
      id
      Action {
        id
        HZDID
        action
        assignedTo
        businessUnit
        status
        dueDate
        originalDueDate
        _delete
        assignedToEmail
        completedDate
        sendEmail
        voidJustification
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        hazardActionsId
        __typename
      }
      ACTID
      logDetails
      personnelName
      files
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      hazardActionsLogsId
      __typename
    }
  }
`;
export const updateHazardActionLog = /* GraphQL */ `
  mutation UpdateHazardActionLog(
    $input: UpdateHazardActionLogInput!
    $condition: ModelHazardActionLogConditionInput
  ) {
    updateHazardActionLog(input: $input, condition: $condition) {
      id
      Action {
        id
        HZDID
        action
        assignedTo
        businessUnit
        status
        dueDate
        originalDueDate
        _delete
        assignedToEmail
        completedDate
        sendEmail
        voidJustification
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        hazardActionsId
        __typename
      }
      ACTID
      logDetails
      personnelName
      files
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      hazardActionsLogsId
      __typename
    }
  }
`;
export const deleteHazardActionLog = /* GraphQL */ `
  mutation DeleteHazardActionLog(
    $input: DeleteHazardActionLogInput!
    $condition: ModelHazardActionLogConditionInput
  ) {
    deleteHazardActionLog(input: $input, condition: $condition) {
      id
      Action {
        id
        HZDID
        action
        assignedTo
        businessUnit
        status
        dueDate
        originalDueDate
        _delete
        assignedToEmail
        completedDate
        sendEmail
        voidJustification
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        hazardActionsId
        __typename
      }
      ACTID
      logDetails
      personnelName
      files
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      hazardActionsLogsId
      __typename
    }
  }
`;
